module.exports = __webpack_public_path__ + "media/images/brands/marque-kerastase@3x-a183dce07181454f6bcb293b08c27c3d.jpg";